// 获取“热门文章”json
export async function requestHotArticles() {
  const result = await fetch(
    'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/ice/hot-article.json',
    {
      method: 'GET',
      mode: 'cors'
    }
  )
  return result.json()
}

// 获取“管理员名单”json
export async function requestMaster() {
  const result = await fetch(
    'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/img/ice/master.json',
    {
      method: 'GET',
      mode: 'cors'
    }
  )
  return result.json()
}

// 获取“管理员名单”json
export async function requestVersionInfo() {
  const result = await fetch(
    `https://style.youkeda.com/img/done/version/version.json?_t=${new Date().getTime()}`,
    {
      method: 'GET',
      mode: 'cors'
    }
  )
  return result.json()
}
